import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Typography from '@material-ui/core/Typography'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
import Divider from '@material-ui/core/Divider'
import TextField from '@material-ui/core/TextField'
import PropTypes from 'prop-types'

import UploadImageComponent from '../../products/components/UploadImageComponent'

const ImageMessage = item => {
  return <img src={item.value} alt="response" />
}

const TextMessage = item => {
  return <Typography>{item.value}</Typography>
}

class AnswerItemList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      responseMessage: props.responseMessage,
      onDeleteResponse: props.onDeleteResponse,
      onAddResponse: props.onAddResponse,
      images: [],
    }
  }

  static propTypes = {
    responseMessage: PropTypes.array.isRequired,
    onDeleteResponse: PropTypes.func.isRequired,
    onAddResponse: PropTypes.func.isRequired,
  }

  static defaultProps = {
    responseMessage: [],
    onDeleteResponse: () => console.log('not implement onDeleteResponse yet'),
    onAddResponse: () => console.log('not implement onAddResponse yet'),
  }

  generateCardList(list, onDeleteResponse) {
    return list.map((item, index) => {
      const id = `answer-item-${index}`
      const message =
        item.type === 'image' ? ImageMessage(item) : TextMessage(item)
      return (
        <div key={id} id={id} style={{minHeight: '50px'}}>
          <ListItem style={{padding: '10px'}}>
            <div style={{width: 'calc(100% - 48px)', display: 'flex'}}>
              {message}
              <ListItemSecondaryAction style={{width: '48px'}}>
                <IconButton
                  aria-label="Delete"
                  onClick={() => {
                    onDeleteResponse(index)
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </div>
          </ListItem>
          <Divider />
        </div>
      )
    })
  }

  onImagesUpdate(images) {
    const {onAddResponse} = this.state
    const image = images[0]
    onAddResponse({type: 'image', value: image.src, image})
  }

  onTextFieldEnter(event) {
    const {onAddResponse} = this.state
    if (event.key === 'Enter') {
      if (event.target.value !== '') {
        const {value} = event.target
        event.target.value = ''
        onAddResponse({
          type: 'text',
          value,
        })
      }
      event.preventDefault()
    }
  }

  render() {
    const {projectId} = this.props
    const {responseMessage, onDeleteResponse, images} = this.state
    const enableAddResponse = responseMessage.length < 5
    return (
      <div>
        <List>{this.generateCardList(responseMessage, onDeleteResponse)}</List>
        {enableAddResponse ? (
          <div>
            <TextField
              id="Add message"
              label="Add message"
              type="Add message"
              name="Add message"
              margin="normal"
              variant="outlined"
              onKeyPress={(event) => {
                this.onTextFieldEnter(event)
              }}
            />
            <UploadImageComponent
              projectId={projectId}
              onUpdate={(key, uploadedImages) => {
                this.onImagesUpdate(uploadedImages)
              }}
              placeholder="Click or drop image here."
              images={images}
            />
          </div>
        ) : null}
      </div>
    )
  }
}

export default AnswerItemList



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/aiSetting/faq/AnswerItemList.js